const generateMileagePackageKey = (mileagePackage) =>
  !!mileagePackage
    ? `${mileagePackage.rate}-${mileagePackage.alloted_mileage}`
    : '';

export default generateMileagePackageKey;
